export default "__VITE_ASSET__D8izA0i3__"